import styles from "./expenseCategoryCard.module.css";
import { Dropdown } from "react-bootstrap";
import { Edit, MoreVertical, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const ExpenseCategoryCard = ({
  item,
  setDeleteModalOpen,
  setSelectecId,
  setEditModalOpen,
  setEditUserData,
}) => {
  return (
    <Link
      className={`${styles.ProspectCard}`}
      onClick={(e) => {
        if (item?.is_primary) return;
        setEditModalOpen(true);
        setEditUserData(item);
      }}
    >
      <div className={`${styles.ProspectCardUnder}`}>
        <div className={`${styles.ProspectCardHeadSection}`}>
          {!item?.is_primary && (
            <Dropdown
              className={`${styles.ActionLeaseBUSec}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Dropdown.Toggle
                className={`${styles.ActionsLeaseBU} ActionsBU`}
                id="dropdown-basic"
              >
                <MoreVertical />
              </Dropdown.Toggle>

              <Dropdown.Menu className={`${styles.ActionsBUList}`}>
                <Dropdown.Item
                  className={`${styles.EditActionsBUListItem}`}
                  onClick={(e) => {
                    setEditModalOpen(true);
                    setEditUserData(item);
                  }}
                >
                  <Edit /> Edit
                </Dropdown.Item>
                <Dropdown.Item
                  className={`${styles.EditActionsBUListItem} ${styles.Delete}`}
                  onClick={(e) => {
                    setDeleteModalOpen(true);
                    setSelectecId(item.id);
                  }}
                >
                  <Trash2 /> Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

          <div className={`${styles.ProsIMGSec}`}>
            <img src="/static/img/category-income.svg" alt="" />
          </div>
          <div className={`${styles.HeadConSec}`}>
            <p className={`${styles.ProsUserName}`}>
              <span className={`${styles.UserName}`}>{item?.title}</span>
            </p>
          </div>
        </div>
        <div className={`${styles.ProspectCardFootSec}`}>
          <p className={`${styles.LeaseConDate}`}>
            {dayjs(item?.created_at).fromNow()}
          </p>
          <span
            style={{ backgroundColor: item?.color }}
            className={`${styles.PublishBadge}`}
          >
            {item?.color}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ExpenseCategoryCard;
